import TwoColWrap from "./two-col-wrap";

export default TwoColWrap;